import {
    FunctionField,
    ListContextProvider,
    TextField,
    useList,
    useLocaleState,
} from "react-admin";
import { DatagridWithHistory } from "shared/src/components/DatagridWithHistory";

export const RepairItemsTable = ({ rentalItems }) => {
    const [locale] = useLocaleState();
    const listContext = useList({ data: rentalItems, resource: "rentalItems" });

    return (
        <ListContextProvider value={listContext}>
            <DatagridWithHistory bulkActionButtons={false} rowClick={false}>
                <FunctionField
                    label="equip.name"
                    render={(record) => record.product?.name?.[locale] || ""}
                />
                <TextField label="equip.labelNumber" source="labelNumber" />
                <FunctionField
                    label="equip.returned"
                    render={(record) => (record.returnedQuantity ? "✔" : "✗")}
                />
            </DatagridWithHistory>
        </ListContextProvider>
    );
};
